import { SkeletonPage } from "./view";
export default SkeletonPage;
